// src/utils/formConstants.js

// Standard custom styles for react-select components across the application
export const genericSelectStyles = {
    control: (provided, state) => ({
        ...provided,
        backgroundColor: '#212529',
        borderColor: state.isFocused ? '#b7343a' : '#495057',
        color: '#fff',
        minHeight: '45px',
        // Note: `height: '45px'` might make it too rigid for multi-selects to expand
        // minHeight is usually better. If `height` is needed, manage it in specific contexts.
        boxShadow: state.isFocused ? '0 0 0 1px #b7343a' : 'none',
        '&:hover': { borderColor: '#b7343a' }
    }),
    valueContainer: (provided) => ({
        ...provided,
        minHeight: '45px', // Use minHeight here too
        padding: '0 6px',
        display: 'flex',
        alignItems: 'center'
    }),
    input: (provided) => ({ ...provided, margin: '0px', color: '#fff', padding: 0 }),
    singleValue: (provided) => ({ ...provided, color: '#fff' }),
    menu: (provided) => ({ ...provided, backgroundColor: '#212529', zIndex: 9999, border: '1px solid #495057' }),
    option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isSelected ? '#b7343a' : state.isFocused ? '#343a40' : '#212529',
        color: '#fff',
        cursor: 'pointer',
        '&:active': { backgroundColor: '#b7343a' }
    }),
    multiValue: (provided) => ({ ...provided, backgroundColor: '#343a40' }),
    multiValueLabel: (provided) => ({ ...provided, color: '#fff' }),
    multiValueRemove: (provided) => ({ ...provided, color: '#fff', ':hover': { backgroundColor: '#b7343a', color: 'white' } }),
};